import React from "react";

const IconCalendar1 = ({ color = "#e31c19" }) => {
  return (
    <svg
      id="Grupo_15578"
      data-name="Grupo 15578"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
    >
      <path
        id="Trazado_14793"
        data-name="Trazado 14793"
        d="M12.021,2.417H10.708V1.688a.437.437,0,1,0-.875,0v.729H6.042V1.688a.438.438,0,0,0-.875,0v.729H3.854a1.606,1.606,0,0,0-1.6,1.6V11.6a1.606,1.606,0,0,0,1.6,1.6h8.167a1.605,1.605,0,0,0,1.6-1.6V4.021A1.606,1.606,0,0,0,12.021,2.417Zm-5.4,6.417V6.208H9.25V8.833Zm2.625.875v2.625H6.625V9.708Zm-6.125-3.5H5.75V8.833H3.125Zm7,0H12.75V8.833H10.125ZM3.854,3.292H5.167v.729a.438.438,0,0,0,.875,0V3.292H9.833v.729a.437.437,0,0,0,.875,0V3.292h1.313a.73.73,0,0,1,.729.729V5.333H3.125V4.021A.73.73,0,0,1,3.854,3.292ZM3.125,11.6v-1.9H5.75v2.625h-1.9A.73.73,0,0,1,3.125,11.6Zm8.9.729h-1.9V9.708H12.75v1.9A.73.73,0,0,1,12.021,12.333Z"
        transform="translate(-0.938 -0.521)"
        fill={color}
      />
      <path
        id="Trazado_14794"
        data-name="Trazado 14794"
        d="M0,0H14V14H0Z"
        fill="none"
      />
    </svg>
  );
};

export default IconCalendar1;
